export default __webpack_public_path__ + "static/media/muhammad.aa751d92.jpeg";